import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import flo1min from '../assets/img/floristics/flo1min-min.jpg'
import flo2min from '../assets/img/floristics/flo2min-min.jpg'
import flo3min from '../assets/img/floristics/flo3min-min.jpg'
import flo4min from '../assets/img/floristics/flo4min-min.jpg'
import flo5min from '../assets/img/floristics/flo5min-min.jpg'
import flo6min from '../assets/img/floristics/flo6min-min.jpg'
import flo7min from '../assets/img/floristics/flo7min-min.jpg'
import flo8min from '../assets/img/floristics/flo8min-min.jpg'
import flo9min from '../assets/img/floristics/flo9min-min.jpg'
import flo10min from '../assets/img/floristics/flo10min-min.jpg'



const T4 = (props) => {
  const arrImgmin = [ flo1min, flo2min, flo3min, flo4min, flo5min, flo6min, flo7min, flo8min, flo9min, flo10min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + 'assets/flo1.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo2.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo3.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo4.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo5.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo6.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo7.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo8.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo9.jpg'},
    { src: process.env.PUBLIC_URL + 'assets/flo10.jpg'},
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/' >
      <ScrollToTopOnMount />
      <Trans i18nKey='T4'>
        <p>
          Природа створила квіти, щоб дарувати хвилю емоцій радості та щастя!
        </p>
        <p>
          Студія фітодизайну «VAZON» створює розкішні букети, ніжні компліменти, інтер'єрні композиції, квіти в корзинках та коробках, щоб радість та щастя дарували Ви. Даруйте красу найдорожчим для Вас людям, дивуйте колег та партнерів, створюйте красу та стиль Вашого простору, підкреслюйте квітковими емоціями найдорожчі події у Вашому житті!
        </p>
        <p>
          Ми з радістю втілимо в життя найвибагливіші побажання клієнта!
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T4)


// WEBPACK FOOTER //
// ./src/page/T4.jsx